export default {
  title: {
    id: 'insurance_policy_details_payment_details_title',
    defaultMessage: 'Payment details',
  },
  nextPayment: {
    id: 'insurance_policy_details_payment_details_next_payment',
    defaultMessage: 'Next payment',
  },
  nextPaymentDate: {
    id: 'insurance_policy_details_payment_details_next_payment_date',
    defaultMessage: 'on {date}',
  },
  totalDue: {
    id: 'insurance_policy_details_payment_details_total_due',
    defaultMessage: 'Total due today',
  },
  onHoldInfoBlockTitleMonthly: {
    id: 'insurance_policy_details_payment_details_payment_failed_info',
    defaultMessage:
      'The last few payments haven’t gone through so you’re not currently covered.',
  },
  onHoldInfoBlockTitleAnnually: {
    id: 'insurance_policy_details_payment_details_on_hold_info_title_annually',
    defaultMessage:
      'The last payment hasn’t gone through so you’re not currently covered.',
  },
  onHoldInfoBlockTitleBiennually: {
    id: 'insurance_policy_details_payment_details_on_hold_info_title_biennually',
    defaultMessage:
      'The last payment hasn’t gone through so you’re not currently covered.',
  },
  infoBlockContentMonthly: {
    id: 'insurance_policy_details_payment_details_payment_failed_info_content',
    defaultMessage:
      'To stay protected, catch up on missed payments. Then, you’ll continue to be charged the monthly amount as usual.',
  },
  infoBlockContentBiennually: {
    id: 'insurance_policy_details_payment_details_on_hold_info_content_biennually',
    defaultMessage:
      'To stay protected for the next 24 months, catch up on the missed payment.',
  },
  infoBlockContentAnnually: {
    id: 'insurance_policy_details_payment_details_on_hold_info_content_annually',
    defaultMessage:
      'To stay protected for the next year, catch up on the missed payment.',
  },
  failedPaymentDuringAttemptPeriodInfoTitle: {
    id: 'insurance_policy_details_payment_details_failed_payment_during_attempt_period_info_title',
    defaultMessage:
      'Your most recent payment didn’t go through. You’re still covered for 14 days after the missed payment.',
  },
  failedPaymentDuringAttemptPeriodInfoContent: {
    id: 'insurance_policy_details_payment_details_failed_payment_during_attempt_period_info_content',
    defaultMessage:
      'Stay protected by catching up on the missed payment. Then, you’ll continue to be charged the monthly amount as usual.',
  },
  updatePaymentMethod: {
    id: 'insurance_policy_details_payment_details_update_payment_method',
    defaultMessage: 'Update payment method',
  },
  updatePaymentMethodButton: {
    id: 'insurance_policy_details_payment_details_update_payment_method_button',
    defaultMessage: 'Update payment method',
  },
  catchUpPaymentButton: {
    id: 'insurance_policy_details_payment_details_catch_up_payment_button',
    defaultMessage: 'Catch up on payments',
  },
  cancelAutoRenewalButton: {
    id: 'insurance_policy_details_payment_details_cancel_auto_renewal_button',
    defaultMessage: 'Cancel auto-renewal',
  },
}
